import React from 'react';
import './customer-attributes.css';

const CustomerAttributes = (props) => {
  const { accountNumberLabelText, accountNumberValue, accountNameLabelText, accountNameValue } = props;
  return (
    <div className="customer-attirbutes">
      <div className="row">
        <div className="col pl-sm-0">
          <span className="account-label-text">{accountNumberLabelText} </span>
          <span className="account-value-text">{accountNumberValue}</span>
        </div>
      </div>
      {accountNameLabelText &&
      <div className="row">
        <div className="col pl-sm-0">
          <span className="account-label-text">{accountNameLabelText} </span>
          <span className="account-value-text">{accountNameValue}</span>
        </div>
      </div>
      }
    </div>
  );
};

export default CustomerAttributes;
